 
// ================== OTHER ==================== //
import { Login } from './other/Login'; 
import { DeleteParticipante } from './other/DeleteParticipante'; 
import { DeleteLink } from './other/DeleteLink'; 
import { AssumirTicket } from './other/AssumirTicket'; 

// ================== LIST ==================== //
import { ListProvincia } from './list/ListProvincia'; 
import { ListPatologia } from './list/ListPatologia';
import { ListFaq } from './list/ListFaq';
import { ListChamada } from './list/ListChamada';
import { ListMotivo } from './list/ListMotivo';
import { ListAllPausa } from './list/ListAllPausa';
import { ListPausa } from './list/ListPausa';
import { ChamadaAgente } from './list/ChamadaAgente';
import { ListRegistoAgente } from './list/ListRegistoAgente';
import { totalCallsInQueue } from './list/totalCallsInQueue';
import { callsInProgress } from './list/callsInProgress';
import { agentsStats } from './list/agentsStats';
import { ListChamadaRegistada } from './list/ListChamadaRegistada';
import { ListDashboardChamadaRegistada } from './list/ListDashboardChamadaRegistada';
import { ListChamadaMovicel } from './list/ListChamadaMovicel';
import { ListChamadaPorAgente } from './list/ListChamadaPorAgente';
import { ListChamadaPorDia } from './list/ListChamadaPorDia';
import { ListDashboard } from './list/ListDashboard';
import { ListTurno } from './list/ListTurno';
import { ListTurnoUser } from './list/ListTurnoUser';
import { ListInformacao } from './list/ListInformacao';
import { ListSolicitacao } from './list/ListSolicitacao';
import { ListReclamacao } from './list/ListReclamacao';
import { ListPacoteInformacao } from './list/ListPacoteInformacao';
import { ListPacoteReclamacao } from './list/ListPacoteReclamacao';
import { ListPacoteSolicitacao } from './list/ListPacoteSolicitacao';
import { ListUserGrupo } from './list/ListUserGrupo';
import { ListMensagemPrivada } from './list/ListMensagemPrivada';
import { ListMensagemGrupo } from './list/ListMensagemgrupo';
import { ListParticipanteGrupo } from './list/ListParticipanteGrupo';
import { ListParticipanteGrupoNew } from './list/ListParticipanteGrupoNew';
import { ListParticipante } from './list/ListParticipante';
import { ListLink } from './list/ListLink';
import { ListUserDirecao } from './list/ListUserDirecao';
import { ListProjeto } from './list/ListProjeto';


import { ListMapaPausa } from './list/ListMapaPausa';
import { ListMes } from './list/ListMes';
import { ListDia } from './list/ListDia';
import { ListEscalaAtividade } from './list/ListEscalaAtividade';
import { ListTurnoTrabalho } from './list/ListTurnoTrabalho';

import { ListMapaSupervisor } from './list/ListMapaSupervisor';
import { ListMapaAlmoco } from './list/ListMapaAlmoco';
import { ListStatusTurno } from './list/ListStatusTurno';

import { Top5Municipio } from './list/Top5Municipio';
import { Top5Pergunta } from './list/Top5Pergunta';
import { Top5Provincia } from './list/Top5Provincia';
import { Dashboardano } from './list/Dashboardano';
import { Dashboardhora } from './list/Dashboardhora';
import { Dashboardmes } from './list/Dashboardmes';
import { TotalDashboard } from './list/TotalDashboard';
import { ListDoc } from './list/ListDoc';
import { ListChamada2 } from './list/ListChamada2';
import { ListProvincia2 } from './list/ListProvincia2';
import { ListFaq2 } from './list/ListFaq2';
import { ListChamadaRelatorio } from './list/ListChamadaRelatorio';
import { ListChamadaRelatorio2 } from './list/ListChamadaRelatorio2';
import { ListDados } from './list/ListDados';

import { ListTicket } from './list/ListTicket';
import { ListStatus } from './list/ListStatus';
import { ListAtualizacao } from './list/ListAtualizacao';
import { ListResponsavel } from './list/ListResponsavel';
import { ListMunicipio } from './list/ListMunicipio';
import { ListSuspensoProjeto } from './list/ListSuspensoProjeto';
import { ListResponsavelProjeto } from './list/ListResponsavelProjeto';
import { ListTarefa } from './list/ListTarefa';
import { ListIniciativa } from './list/ListIniciativa';
import { ListDirecao } from './list/ListDirecao';
import { ListObjetivo } from './list/ListObjetivo';
import { ListCriticidade } from './list/ListCriticidade';

import { ListSuspensoTarefa } from './list/ListSuspensoTarefa';
import { ListAtualizacaoTarefa } from './list/ListAtualizacaoTarefa';
import { ListResponsavelTarefa } from './list/ListResponsavelTarefa';
import { ListTarefaAprovacao } from './list/ListTarefaAprovacao';
import { ListUnidade } from './list/ListUnidade';
import { ListEtapa } from './list/ListEtapa';
import { ListRelatorioTarefa } from './list/ListRelatorioTarefa';
import { ListHorasCusto } from './list/ListHorasCusto';
import { ListTarefaCusto } from './list/ListTarefaCusto';
import { ListLogisticaSala } from './list/ListLogisticaSala';
import { ListHorarioLogicaSala } from './list/ListHorarioLogicaSala';
import { ListLogisticaSalaAprovacao } from './list/ListLogisticaSalaAprovacao';
import { ListSala } from './list/ListSala';
import { ListEscritorio } from './list/ListEscritorio';
import { ListTransacao } from './list/ListTransacao';
import { ListVeiculo } from './list/ListVeiculo';
import { ListLogisticaVeiculo } from './list/ListLogisticaVeiculo';
import { ListLogisticaVeiculoAprovacao } from './list/ListLogisticaVeiculoAprovacao';
import { ListHorarioLogisticaVeiculo } from './list/ListHorarioLogisticaVeiculo';
import { ListUser } from './list/ListUser';
import { ListTipos } from './list/ListTipos';
import { ListFalta } from './list/ListFalta';
import { ListFaltaAprovacao } from './list/ListFaltaAprovacao';
import { ListFerias } from './list/ListFerias';
import { ListFeriasAprovacao } from './list/ListFeriasAprovacao';
import { ListFeriasAprovacaoSecretariado } from './list/ListFeriasAprovacaoSecretariado';
import { ListTicketMovicel } from './list/ListTicketMovicel';



// ================== ADD ==================== //
import { AddChamada } from './add/AddChamada';
import { AddPausa } from './add/AddPausa';
import { AbrirTurno } from './add/AbrirTurno';
import { AddChamadaMovicel } from './add/AddChamadaMovicel';
import { AddIndisponibilidade } from './add/AddIndisponibilidade';
import { AddMensagemPrivada } from './add/AddMensagemPrivada';
import { AddMensagemGrupo } from './add/AddMensagemGrupo';
import { AddParticipante } from './add/AddParticipante';
import { AddGrupo } from './add/AddGrupo';
import { AddDoc } from './add/AddDoc';
import { AddChamada2 } from './add/AddChamada2';
import { AddLink } from './add/AddLink';
import { AddPdf } from './add/AddPdf';
import { AddAtualizacao } from './add/AddAtualizacao';
import { AddProjeto } from './add/AddProjeto';
import { AddInicitiva } from './add/AddInicitiva';
import { AddDirecao } from './add/AddDirecao';
import { AddObjetivo } from './add/AddObjetivo';
import { addAtualizacaoTarefa } from './add/addAtualizacaoTarefa';
import { AddTarefa } from './add/AddTarefa';
import { AddEtapa } from './add/AddEtapa';
import { AddLogisticaSala } from './add/AddLogisticaSala';
import { AddLogisticaVeiculo } from './add/AddLogisticaVeiculo';
import { AddFalta } from './add/AddFalta';
import { AddFeria } from './add/AddFeria';
import { AddTicketMovicel } from './add/AddTicketMovicel';

// ================== ALTER ==================== //
import { AlterPausa } from './alter/AlterPausa';
import { FecharTurno } from './alter/FecharTurno';
import { AlterLink } from './alter/AlterLink';
import { AlterTicket } from './alter/AlterTicket';
import { AlterProjeto } from './alter/AlterProjeto';
import { AlterStatusProjeto } from './alter/AlterStatusProjeto';
import { AlterIniciativa } from './alter/AlterIniciativa';
import { AlterDirecao } from './alter/AlterDirecao';
import { AlterObjetivo } from './alter/AlterObjetivo';
import { AlterTarefa } from './alter/AlterTarefa';
import { AlterStatusTarefa } from './alter/AlterStatusTarefa';
import { AprovarTarefa } from './alter/AprovarTarefa';
import { AlterEtapa } from './alter/AlterEtapa';
import { AlterLogisticaSala } from './alter/AlterLogisticaSala';
import { AlterLogisticaVeiculo } from './alter/AlterLogisticaVeiculo';
import { AlterUserSalario } from './alter/AlterUserSalario';
import { AlterUserDados } from './alter/AlterUserDados';
import { JustificarFalta } from './alter/JustificarFalta';
import { AprovarFeria } from './alter/AprovarFeria';
import { AprovarFeriaSecretariado } from './alter/AprovarFeriaSecretariado';
import { FecharTicketMovicel } from './alter/FecharTicketMovicel';



const Api = {
Login, 
ListProvincia,
ListPatologia,
ListFaq,
ListChamada,
AddChamada,
AddPausa,
ListMotivo,
ListPausa,
AlterPausa,
ListAllPausa,
ChamadaAgente,
ListRegistoAgente,
agentsStats,
callsInProgress,
totalCallsInQueue,
ListChamadaRegistada,
ListDashboardChamadaRegistada,
ListChamadaMovicel,
ListChamadaPorAgente,
ListChamadaPorDia,
ListDashboard,
FecharTurno,
ListTurno,
AbrirTurno,
ListTurnoUser,
ListInformacao,
ListSolicitacao,
ListReclamacao,
ListPacoteInformacao,
ListPacoteReclamacao,
ListPacoteSolicitacao,
AddChamadaMovicel,
AddIndisponibilidade,
ListUserGrupo,
ListMensagemGrupo,
ListMensagemPrivada,
AddMensagemPrivada,
AddMensagemGrupo,
ListParticipanteGrupo,
ListParticipanteGrupoNew,
DeleteParticipante,
AddParticipante,
ListParticipante,
AddGrupo,
ListMes,
ListDia,
ListEscalaAtividade,
ListTurnoTrabalho,
ListMapaPausa,
ListMapaSupervisor,
ListMapaAlmoco,
ListStatusTurno,
TotalDashboard,
Dashboardmes,
Dashboardhora,
Dashboardano,
Top5Provincia,
Top5Pergunta,
Top5Municipio,
AddDoc,
ListDoc,
ListChamada2,
ListProvincia2,
ListFaq2,
AddChamada2,
ListChamadaRelatorio,
ListChamadaRelatorio2,
ListMunicipio,
ListLink,
DeleteLink,
AddPdf,
AddLink,
AlterLink,
ListDados,
ListTicket,
ListStatus,
ListAtualizacao,
ListResponsavel,
AddAtualizacao,
AlterTicket,
AssumirTicket,
ListUserDirecao,
ListProjeto,
AlterProjeto,
AddProjeto,
AlterStatusProjeto,
ListSuspensoProjeto,
ListResponsavelProjeto,
ListIniciativa,
AddInicitiva,
AlterIniciativa,
AddDirecao,
ListDirecao,
AlterDirecao,
ListObjetivo,
AddObjetivo,
AlterObjetivo,
ListCriticidade,
ListTarefa,
addAtualizacaoTarefa,
AddTarefa,
AlterTarefa,
AlterStatusTarefa,
ListSuspensoTarefa,
ListAtualizacaoTarefa,
ListResponsavelTarefa,
AprovarTarefa,
ListTarefaAprovacao,
ListRelatorioTarefa,
ListHorasCusto,
ListTarefaCusto,
AddEtapa,
ListEtapa,
AlterEtapa,
ListLogisticaSala,
ListHorarioLogicaSala,
AlterLogisticaSala,
AddLogisticaSala,
ListLogisticaSalaAprovacao,
ListEscritorio,
ListSala,
ListUser,
ListHorarioLogisticaVeiculo,
ListLogisticaVeiculoAprovacao,
ListLogisticaVeiculo,
ListVeiculo,
AddLogisticaVeiculo,
AlterLogisticaVeiculo,
AlterUserSalario,
ListTransacao,
AlterUserDados,
ListTipos,
AddFalta,
ListFalta,
ListFaltaAprovacao,
JustificarFalta,
AprovarFeria,
AddFeria,
ListFerias,
ListFeriasAprovacao,
AprovarFeriaSecretariado,
ListFeriasAprovacaoSecretariado,
FecharTicketMovicel,
AddTicketMovicel,
ListTicketMovicel,
 };


export default Api;